module.exports = __webpack_public_path__ + "img/357c9d5.jpg";